import React, { useMemo, useState } from 'react';
import { exportSchedulesToExcel } from '@/lib/exportExcel';
import { getTimeSlotsForDate, formatToYYYYMMDD } from '@/lib/dateUtils';

const todayISO = () => formatToYYYYMMDD(new Date());

const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

const toDateAtLocalMidnight = (value) => {
  return new Date(`${value}T00:00:00`);
};

const ExportRangePanel = ({
  schedules,
  viewMode,
  selectedGroup,
  selectedTeacher,
}) => {
  const [start, setStart] = useState(todayISO());
  const [end, setEnd] = useState(formatToYYYYMMDD(addDays(new Date(), 13)));

  const disabled = !schedules || schedules.length === 0;

  const filteredForExport = useMemo(() => {
    const startDate = toDateAtLocalMidnight(start);
    const endDate = toDateAtLocalMidnight(end);

    const inRange = (d) => {
      const dd = new Date(d);
      return dd >= startDate && dd <= endDate;
    };

    let base = schedules.filter((s) => inRange(s.date));

    if (viewMode === 'by_group' && selectedGroup) {
      base = base.filter((s) => s.group_name === selectedGroup);
    } else if (viewMode === 'by_teacher' && selectedTeacher) {
      base = base.filter((s) => s.teacher === selectedTeacher);
    }

    base.sort((a, b) => {
      const da = new Date(a.date).getTime();
      const db = new Date(b.date).getTime();
      if (da !== db) return da - db;

      // ✅ Отримуємо правильний список слотів для конкретної дати
      const slots = getTimeSlotsForDate(new Date(a.date));

      const sa = slots.indexOf(a.time_slot);
      const sb = slots.indexOf(b.time_slot);
      if (sa !== sb) return sa - sb;

      return String(a.group_name).localeCompare(String(b.group_name), 'uk', { sensitivity: 'base' });
    });

    return base;
  }, [schedules, start, end, viewMode, selectedGroup, selectedTeacher]);

  const handleExport = async () => {
    const filename = `rozklad_${start}__${end}.xlsx`;
    await exportSchedulesToExcel(filteredForExport, filename);
  };

  return (
    <div className="flex gap-2 items-center">
      <div className="flex flex-col">
        <input
          type="date"
          value={start}
          onChange={(e) => setStart(e.target.value)}
          className="border px-2 py-1 rounded text-sm"
        />
      </div>

      <div className="flex flex-col">
        <input
          type="date"
          value={end}
          onChange={(e) => setEnd(e.target.value)}
          className="border px-2 py-1 rounded text-sm"
        />
      </div>

      <div className="flex flex-row gap-2">
        <button
          onClick={handleExport}
          disabled={filteredForExport.length === 0 || !start || !end || toDateAtLocalMidnight(start) > toDateAtLocalMidnight(end)}
          className="bg-primary text-white text-sm px-3 py-1 rounded hover:opacity-90"
          title={filteredForExport.length === 0 ? 'Дані ще завантажуються або відсутні' : 'Експортувати в Excel'}
        >
          🔃 Експортувати в Excel
        </button>
      </div>
    </div>
  );
};

export default ExportRangePanel;
